const mobileMenuSubMenuButtons = document.querySelectorAll( '.mobile-header-main-menu button' )
const mobileMenuButton = document.getElementById( 'mobileMenuButton' )
const mobileMenus = document.getElementById( 'mobileMenus' )
let   mobileMenuIsTransitioning = false

const init = function() {


    const closeMenu = function() {

        mobileMenus.style.opacity = '0'
        mobileMenus.style.right   = '-100%'

        setTimeout( () => {
            mobileMenus.style.display = 'none'
            mobileMenuIsTransitioning = false
        }, 750 )

    }

    if ( mobileMenuButton ) {

        mobileMenuButton.addEventListener( 'click', () => {
            
            if ( mobileMenuIsTransitioning ) return

            mobileMenuIsTransitioning = true
            
            const expanded = mobileMenuButton.getAttribute( 'aria-expanded' ) === 'true' ? false : true

            mobileMenuButton.setAttribute( 'aria-expanded', expanded )

            // Open menu
            if ( expanded ) {

                mobileMenus.style.display = 'block'

                setTimeout( () => {
                    mobileMenus.style.opacity = '1'
                    mobileMenus.style.right   = '0'
                    mobileMenuIsTransitioning = false
                }, 5 )
            
            // Close menu
            } else {

                closeMenu()

            }

        } )

        document.onkeydown = function( evt ) {

            if ( evt.key === 'Escape' ) {
    
                if ( mobileMenuIsTransitioning ) return
                            
                const expanded = mobileMenuButton.getAttribute( 'aria-expanded' ) === 'true' ? false : true
    
                // Close menu
                if ( !expanded ) {
    
                    mobileMenuIsTransitioning = true
                    mobileMenuButton.setAttribute( 'aria-expanded', false )
                    closeMenu()
                    mobileMenuButton.focus()
                    
                }
    
            }
    
        };

    }

    if ( mobileMenuSubMenuButtons ) {

        mobileMenuSubMenuButtons.forEach( button => {

            let transitioning = false
            const subMenu = button.nextElementSibling

            button.addEventListener( 'click', () => {

                if ( transitioning ) return

                transitioning = true

                if ( subMenu.hasAttribute( 'style' ) ) {

                    subMenu.style.height = subMenu.scrollHeight + 'px'

                    setTimeout( () => {
                        button.setAttribute( 'aria-expanded', 'false' )
                        subMenu.style.height = '0px'
                    }, 5 )
                                        
                    setTimeout( () => {
                        subMenu.removeAttribute( 'style' )
                        transitioning = false
                    }, 245 )

                } else {

                    button.setAttribute( 'aria-expanded', 'true' )
                    subMenu.style.display = 'block'

                    setTimeout( () => {
                        subMenu.style.height = subMenu.scrollHeight + 'px'
                    }, 5 )
                    setTimeout( () => {
                        subMenu.style.height = 'auto'
                        transitioning = false
                    }, 245 )

                }

            } )


        } )

    }

}


const api = {
    init: init
}


export default api;
